import styles from "./CarouselTitle.module.scss";
import { ReactNode } from "react";
import { formatNumberWithCommas } from "helpers/utility/formatters";
import { Tooltip } from "antd";
import { InfoIcon } from "../../../../DatasetInventory/DatasetInfoIcon/Icons";

export const CarouselTitle = ({
  text,
  count,
  tooltipText,
  children,
}: {
  children?: ReactNode;
  text: string;
  count: number;
  tooltipText?: string;
}) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <span>{text}</span>
      {count > 0 && (
        <span className={styles.count}>{formatNumberWithCommas(count)}</span>
      )}
      {tooltipText && (
        <Tooltip title={tooltipText}>
          <InfoIcon />
        </Tooltip>
      )}
    </div>
    {children}
  </div>
);
